import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileBottomBar } from "@/components/MobileBottomBar";
import { FinalCtaSection } from "@/components/FinalCtaSection";
import { ServiceRevOpsHero } from "@/components/service-revops-hero";
import { ServicePainAndProof } from "@/components/service-revops-pain-proof";
import { ServiceArchitectureSection } from "@/components/service-revops-architecture";
import { ServiceVoiceAiComparison } from "@/components/ServiceVoiceAiComparison";
import { ServiceCostAndProcess } from "@/components/service-revops-cost-process";
import { ServiceTestimonials } from "@/components/service-revops-testimonials";
import { ServiceBuilds } from "@/components/service-revops-builds";
import { ServiceVetting } from "@/components/service-revops-vetting";
import { ServiceMigration } from "@/components/service-revops-migration";
import { ServiceIndustries } from "@/components/service-revops-industries";
import { ServiceSnapshots } from "@/components/service-revops-snapshots";
import {
  ServicePricing,
  ServiceFreeAudit,
  ServiceWhoIAm,
} from "@/components/service-revops-pricing-trust";
import {
  ServiceCaseStudies,
  ServiceFaq,
} from "@/components/service-revops-cases-faq";
import { voiceAiConfig } from "@/components/service-voiceai-config";

export default function ServiceVoiceAI() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cfg = voiceAiConfig;

  return (
    <main
      className="min-h-screen relative pb-[72px] md:pb-0"
      style={{ background: "#FFFFFF" }}
    >
      <MobileBottomBar />
      <Navbar />

      {/* §1 Hero (includes live-proof marquee below CTA) */}
      <ServiceRevOpsHero config={cfg} />

      {/* §2 Pain Diagnosis (CTA inside section) */}
      <ServicePainAndProof config={cfg} />

      {/* §3 Architecture Builds Showcase & Capabilities (CTA inside section) */}
      <ServiceArchitectureSection config={cfg} />

      {/* §3b Speed/Latency & Voice AI Governance Stack */}
      <ServiceVoiceAiComparison />

      {/* §4 Cost of Inaction + §5 Build Process (CTA inside section) */}
      <ServiceCostAndProcess config={cfg} />

      {/* System Rescue & Migration (CTA inside section) */}
      <ServiceMigration config={cfg} />

      {/* Testimonials (CTA inside section) */}
      <ServiceTestimonials config={cfg} />

      {/* What I Build (CTA inside section) */}
      <ServiceBuilds config={cfg} />

      {/* Architecture Library preview (CTA inside section) */}
      <ServiceSnapshots config={cfg} />

      {/* Industries I Build For (CTA inside section) */}
      <ServiceIndustries config={cfg} />

      {/* How to Vet a Voice AI Architect (CTA inside section) */}
      <ServiceVetting config={cfg} />

      {/* §12 Pricing & Value */}
      <ServicePricing config={cfg} />

      {/* §13 Free Voice AI Audit */}
      <ServiceFreeAudit config={cfg} />

      {/* §14 Who I Am / Trust (CTA inside section) */}
      <ServiceWhoIAm config={cfg} />

      {/* §15 Architecture Guides */}
      <ServiceCaseStudies config={cfg} />

      {/* §16 FAQ (CTA inside section) */}
      <ServiceFaq config={cfg} />

      {/* §17 Final CTA */}
      <FinalCtaSection />
      <Footer />
    </main>
  );
}
